<template>
  <a-drawer
    title="财报详情"
    placement="right"
    :closable="true"
    :visible="visible"
    :destroyOnClose="true"
    :maskClosable="false"
    :width="1050"
    @close="handleCancel"
  >
    <a-tabs tab-position="left">
      <a-tab-pane :key="tab.key" :tab="tab.tab" v-for="tab in tabs">
        <a-table
          bordered
          size="small"
          :columns="tab.columns()"
          :data-source="tab.dataSource()"
          :scroll="{ x: 500, y: 700 }"
          :pagination="false"
        >
          <span
            slot="label"
            slot-scope="text, record"
            :class="[record.bold ? 'font-bold' : '']"
            :style="{
              paddingLeft:
                record.paddingLeft || (tab.key == 'profit' ? '0px' : '40px'),
            }"
          >
            {{ text }}
          </span>
          <span
            slot="yearStartAmount"
            slot-scope="text, record"
            :class="[record.bold ? 'font-bold' : '']"
          >
            <span v-if="record.noFormat">{{ text }}</span>
            <span v-else>{{ text | formatAmount }}</span>
          </span>
          <span
            slot="yearEndAmount"
            slot-scope="text, record"
            :class="[record.bold ? 'font-bold' : '']"
          >
            <span v-if="record.noFormat">{{ text }}</span>
            <span v-else>{{ text | formatAmount }}</span>
          </span>
        </a-table>
      </a-tab-pane>
    </a-tabs>
  </a-drawer>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import {
  BALANCE_KEY_TITLE_OBJ,
  PROFIT_KEY_TITLE_OBJ,
  CASH_FLOW_KEY_TITLE_OBJ,
} from '../const'

export default {
  name: 'FinanceTableModal',
  data() {
    return {
      tabs: [
        {
          key: 'balance',
          tab: '资产负债表',
          columns: () => {
            return this.balanceColumns
          },
          dataSource: () => {
            return this.balanceTableData
          },
        },
        {
          key: 'profit',
          tab: '损益表',
          columns: () => {
            return this.profitColumns
          },
          dataSource: () => {
            return this.profitTableData
          },
        },
        {
          key: 'cashFlow',
          tab: '现金流量表',
          columns: () => {
            return this.cashFlowColumns
          },
          dataSource: () => {
            return this.cashFlowTableData
          },
        },
      ],
    }
  },
  props: ['visible', 'dataSource', 'selectedRows'],
  computed: {
    balanceColumns() {
      const selectedRows = this.selectedRows
      const timeColumns = selectedRows.map(item => {
        const { reportTime, id } = item
        return {
          title: reportTime,
          children: [
            {
              title: '年初值',
              dataIndex: `yearStartAmount_${id}`,
              key: `yearStartAmount_${id}`,
              scopedSlots: { customRender: 'yearStartAmount' },
            },
            {
              title: '年末值',
              dataIndex: `yearEndAmount_${id}`,
              key: `yearEndAmount_${id}`,
              scopedSlots: { customRender: 'yearEndAmount' },
            },
          ],
        }
      })
      const balanceColumns = [
        {
          title: '元素',
          dataIndex: 'title',
          key: 'title',
          width: 240,
          fixed: 'left',
          scopedSlots: { customRender: 'label' },
        },
        ...timeColumns,
      ]
      return balanceColumns
    },
    balanceTableData() {
      const dataSource = this.dataSource
      return this.dataSource2TableList(
        dataSource,
        'balance',
        BALANCE_KEY_TITLE_OBJ,
      )
    },
    profitColumns() {
      const selectedRows = this.selectedRows
      const timeColumns = selectedRows.map(item => {
        const { reportTime, id } = item
        return {
          title: reportTime,
          children: [
            {
              title: '本期金额',
              dataIndex: `yearStartAmount_${id}`,
              key: `yearStartAmount_${id}`,
              scopedSlots: { customRender: 'yearStartAmount' },
            },
            {
              title: '截止本期当年累计金额',
              dataIndex: `yearEndAmount_${id}`,
              key: `yearEndAmount_${id}`,
              scopedSlots: { customRender: 'yearEndAmount' },
            },
          ],
        }
      })
      const profitColumns = [
        {
          title: '元素（项目）',
          dataIndex: 'title',
          key: 'title',
          width: 220,
          fixed: 'left',
          scopedSlots: { customRender: 'label' },
        },
        ...timeColumns,
      ]
      return profitColumns
    },
    profitTableData() {
      const dataSource = this.dataSource
      return this.dataSource2TableList(
        dataSource,
        'profit',
        PROFIT_KEY_TITLE_OBJ,
      )
    },
    cashFlowColumns() {
      const selectedRows = this.selectedRows
      const timeColumns = selectedRows.map(item => {
        const { reportTime, id } = item
        return {
          title: reportTime,
          children: [
            {
              title: '金额',
              dataIndex: `yearStartAmount_${id}`,
              key: `yearStartAmount_${id}`,
              scopedSlots: { customRender: 'yearStartAmount' },
            },
          ],
        }
      })
      const cashFlowColumns = [
        {
          title: '元素（项目）',
          dataIndex: 'title',
          key: 'title',
          width: 450,
          fixed: 'left',
          scopedSlots: { customRender: 'label' },
        },
        ...timeColumns,
      ]
      return cashFlowColumns
    },
    cashFlowTableData() {
      const dataSource = this.dataSource
      return this.dataSource2TableList(
        dataSource,
        'cashFlow',
        CASH_FLOW_KEY_TITLE_OBJ,
      )
    },
  },
  methods: {
    /**
     * 将后端返回的数据构造为table的list数据
     * dataSource: 后端返回的数据，形如：[{ balance: { c52: 0, d52: 0 }, id: '1273163736605011970' }]
     * keyName: 取 dataSource 中哪个数据，若为 'balance' 则取 dataSource.balance 数据
     * KEY_TITLE_OBJ: 表格第一列的 title 与后端返回的对应命名数据的值，如 dataSource.balance 中 c52对应 '资产总计'的年初值，d52对应年末值，则 key = 'c_52_d'
     */
    dataSource2TableList(dataSource, keyName, KEY_TITLE_OBJ) {
      let item = {}
      const list = []
      Object.keys(KEY_TITLE_OBJ).forEach(key => {
        item.title = KEY_TITLE_OBJ[key].title
        item.bold = KEY_TITLE_OBJ[key].bold || false
        item.noFormat = KEY_TITLE_OBJ[key].noFormat || false
        item.paddingLeft = KEY_TITLE_OBJ[key].paddingLeft || false
        item.key = key
        // 如 dataSource.balance 中 c52对应 '资产总计'的年初值，d52对应年末值，则 key = 'c_52_d'
        // 若 对应行为空，则 key = 'EMPTY_N'
        const start_num_end = item.key.split('_')
        const startKey = start_num_end[0],
          num = start_num_end[1],
          endKey = start_num_end.length === 3 ? start_num_end[2] : ''
        dataSource.forEach(data => {
          const id = data.id
          if (startKey === 'EMPTY') {
            item[`yearStartAmount_${id}`] = ''
            item[`yearEndAmount_${id}`] = ''
          } else {
            const info = data[keyName]
            item[`yearStartAmount_${id}`] = info[`${startKey}${num}`]
            item[`yearEndAmount_${id}`] =
              (endKey && info[`${endKey}${num}`]) || ''
          }
        })
        list.push(cloneDeep(item))
        item = {}
      })
      return list
    },
    handleCancel() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .ant-table-content .font-bold {
  font-weight: bold;
}
</style>
